// Parts shared by several default workouts. Warm-ups and cool-downs are routines now (../routines, 2026-10-14).
import type { Section } from '../types';
import { ids, reps } from './plan';

/**
 * Ramp-up sets before the first heavy lift of a gym day, so the planned time is honest: about 4 minutes
 * (empty bar, then about 50 and 75 percent of the work weight, with time to load plates). Part of the main work
 * (kind "main" since 2026-10-14), so choosing or switching off the warm-up routine never drops them.
 */
export const rampUp = (exerciseId: string): Section => ({
  id: 'ramp', kind: 'main', format: { kind: 'sets', sets: 3, restSec: 90 }, blocks: ids('ramp', [
    { exerciseId, amount: reps(5), note: 'ramp-up: empty bar, then about 50 and 75 percent of the work weight' },
  ]),
});
